import { APP_FONT_SIZE_KEY, AppFontSize, DEFAULT_APP_FONT_SIZE, isAppFontSize } from "@src/constants/appFontSize";
import { getUserSetting } from "./storage.utils";

export const readAppFontSize = (): AppFontSize => {
	const stored = getUserSetting(APP_FONT_SIZE_KEY, "");
	return isAppFontSize(stored) ? stored : DEFAULT_APP_FONT_SIZE;
};

export const applyAppFontSize = (size: AppFontSize) => {
	document.documentElement.dataset.fontSize = size;
};
